export const statusOptions = [
    { label: "Yes", value: "Yes"},
    { label: "No", value: "No"}
]